<template>
  <div class="filter-container tw-flex tw-gap-2 tw-items-center">
    <UsersFilter :options="usersOptions" />

    <div class="tw-inline-block tw-min-w-[150px]">
      <TypesFilter />
    </div>

    <SearchFilter />
  </div>
</template>

<script setup lang="ts">
import UsersFilter from './users-filter.vue'
import TypesFilter from './types-filter.vue'
import SearchFilter from './search-filter.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  usersOptions?: Array<{
    id: string
    options: Array<{
      label: string
      value: string
      icon?: string
      iconColor?: string
    }>
  }>
}

const props = defineProps<Props>()
const I18n = useI18n()

const usersOptions = props.usersOptions ?? [
  {
    id: 'users',
    options: [
      { label: I18n.t('assistant_check.filters.labels.me'), value: 'me' },
      {
        label: I18n.t('assistant_check.filters.labels.nobody'),
        value: 'nobody',
      },
    ],
  },
]
</script>
